export type Comune = {
    nome: string;
    zona: string;
}

export enum ClimateZone {
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    E = "E",
    F = "F",
}

export enum TerminalType {
    BASSA = "bassa",
    MEDIA = "media",
}

export type IncentiviByZone = {
    [key in ClimateZone]: number;
};

export type HeatPumpProduct = {
    modello: string;
    pn: {
        media: number;
        bassa: number;
    };
    incentivi: {
        media: IncentiviByZone;
        bassa: IncentiviByZone;
    };
    hide: boolean;
    scop: {
        media: number;
        bassa: number;
    };
    ηs: {
        media: number;
        bassa: number;
    };
};

export type WaterHeaterProduct = {
    modello: string;
    pn: number;
    classe: string;
    incentivoSingolo: string;
    hide: boolean;
    cop: number;
};

export type SolarProduct = {
    modello: string;
    qu: number;
    qcol: number;
    ag: number;
    servizio: {
        [key: string]: {
            ci?: number;
            pannelli: {
                [key: string]: {
                    ci?: number;
                    sl: number;
                    iatot: number;
                    incentivo: number;
                };
            };
        };
    };
    hide: boolean;
};

export type SolarService = {
    id: string;
    nome: string;
};

export enum ProductTypeId {
    PDC = "pdc",
    IBRIDO_FACTORY = "ibrido_factory",
    IBRIDO_BIVALENTE_LT35 = "ibrido_bivalente_lt35",
    IBRIDO_BIVALENTE_GT35 = "ibrido_bivalente_gt35",
    SCALDACQUA = "scaldacqua",
    SOLARE = "solare",
}

export type HeatPumpProductTypeId =
    | ProductTypeId.PDC
    | ProductTypeId.IBRIDO_FACTORY
    | ProductTypeId.IBRIDO_BIVALENTE_LT35
    | ProductTypeId.IBRIDO_BIVALENTE_GT35;
